"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ExclamationTriangle = function ExclamationTriangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$translateKey = _ref.translateKey,
      translateKey = _ref$translateKey === void 0 ? null : _ref$translateKey;
  var iconSize = size === 'original' ? 'width="20" height="21"' : 'width="100%"';
  var title;

  if (translateKey) {
    title = translateKey('Exclamation');
  } else {
    title = 'Exclamation';
  }

  return "\n  <svg ".concat(iconSize, " aria-label=\"").concat(title, "\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>").concat(title, "</title>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.10717 2.30963C9.47688 1.57698 10.523 1.57698 10.8927 2.30963L18.9365 18.25C19.2722 18.9151 18.7888 19.7005 18.0438 19.7005H1.95612C1.21112 19.7005 0.727716 18.9151 1.06334 18.25L9.10717 2.30963Z\" fill=\"#FFC20E\"/>\n  <rect x=\"8.8\" y=\"8.50049\" width=\"2.4\" height=\"6.4\" rx=\"1\" fill=\"white\"/>\n  <rect x=\"8.8\" y=\"15.7005\" width=\"2.4\" height=\"2.4\" rx=\"1\" fill=\"white\"/>\n  </svg>  \n    ");
};

var _default = ExclamationTriangle;
exports["default"] = _default;